import { configureStore } from "@reduxjs/toolkit";
import createroomreducer from "./VoiceToTextSlice"
import transcriber from "./TranscriptionSlice";
import MeetingCodeSlice from "./GetMeetingCodeSlice";


const Store = configureStore({
    reducer:{
        createRoom:createroomreducer,
        transcriptionData:transcriber,
        meetingCode:MeetingCodeSlice
        
     
    }
})

export default Store;